export function NotFound() {
  return (
    <div>
      <h1>404!</h1>
      <p>你要访问的页面不存在</p>
    </div>
  );
}
